import React from 'react';
import { connect } from 'react-redux';
import { Col, Row } from 'antd';
import DocumentTypes from './DocumentTypes';

const TopPanel = props => {
  const { typesList, totalOffers, onChangeTypeList, stat } = props;

  return (
    <Row>
      <Col span={18}>
        <div className="orders__states">
          <DocumentTypes
            totalOrders={totalOffers}
            typesList={typesList}
            stat={stat}
            onChangeTypeList={onChangeTypeList}
          />
        </div>
      </Col>
      <Col span={6}>
        {/*<Search*/}
        {/*  placeholder="Поиск по заказам"*/}
        {/*  onChange={onChangeSearch}*/}
        {/*  value={searchValue}*/}
        {/*  onSearch={handleSearchOffers}*/}
        {/*  style={{ width: '100%' }}*/}
        {/*/>*/}
      </Col>
    </Row>
  );
};

export default connect(state => ({
  searchValue: state.Executorship.Offers.filters.search,
}))(TopPanel);
